import React from 'react';
import { useLingui } from '@lingui/react/macro';
import type { PaginationProps } from 'antd';

import { Pagination } from './styled.ts';

export type BasePaginationProps = PaginationProps & {
    contentText?: string;
};

// TODO: styling pagination from figma
export const BasePagination: React.FC<BasePaginationProps> = ({ contentText, ...props }) => {
    const { t } = useLingui();
    const DEFAULT_TEXT = t`Results per page`;

    return (
        <Pagination
            {...props}
            showSizeChanger={{ showSearch: false }}
            showTitle={false}
            locale={{ items_per_page: '' }}
            contentText={contentText ?? DEFAULT_TEXT}
        />
    );
};
